// Antd
import { Slider } from 'antd'

// Interfaces
import { IBaseSliderProps } from './interfaces'

const BaseSlider = (props: IBaseSliderProps) => {
  return (
    <Slider
      trackStyle={{
        backgroundColor: '#0055fa',
        height: 8,
        borderRadius: '100px 0px 0px 100px',
        ...props?.trackStyle,
      }}
      handleStyle={{
        width: 20,
        height: 20,
        background: '#f4f6f8',
        border: '7px solid #0055FA',
        ...props?.handleStyle,
      }}
      {...props}
    />
  )
}

export { BaseSlider }
